import { SEC_DataApiPost } from '../func.js';


/** Add one link to the authenticated user's personal dashboard links. */
export function addPersonalExternalLink(link) {
    return SEC_DataApiPost(
        'dashboard/personalExternalLinks/add',
        JSON.stringify(link),
        {},
        () => {}
    );
}


/** Delete one exact link from the authenticated user's personal dashboard links. */
export function deletePersonalExternalLink(link) {
    return SEC_DataApiPost(
        'dashboard/personalExternalLinks/delete',
        JSON.stringify(link),
        {},
        () => {}
    );
}
